import { render, staticRenderFns } from "./tenantsList.vue?vue&type=template&id=3932cebc&"
import script from "./tenantsList.vue?vue&type=script&lang=js&"
export * from "./tenantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports